import React, { useEffect, useState } from "react"
import { Button, InputBase } from "@material-ui/core"
import { Send as SendIcon } from "@material-ui/icons"
import useStore from "src/v2/utils/store"
// @ts-ignore
import { useParams } from "react-router-dom"
import AskAIfeedback from "./ask-ai-feedback"
import useASTStore from "../../utils/AST-store"

export default function AskAIChat() {
  const [messages, setMessages] = useState([])
  const [newMessage, setNewMessage] = useState("")
  const [loading, setLoading] = useState(false)
  const askAI = useStore((state) => state.askAI)
  const goto = useASTStore((state) => state.goto)
  const { reviewId } = useParams()

  useEffect(() => {
    addInitialMessage()
  }, [])

  const addInitialMessage = () => {
    setMessages([
      {
        id: 1,
        role: "System",
        text: "Hi! I'm your Smart Contract Security Assistant. I can help you understand the smart-contract functionality and source-code for a better review. Ask me anything about its behavior!",
      },
    ])
  }

  useEffect(() => {
    if (loading) {
      const fetchResponse = async () => {
        await getAndSetResponseFromSystem(newMessage.trim())
        setLoading(false)
      }
      fetchResponse()
    }
  }, [messages])

  const handleSendMessage = () => {
    if (newMessage.trim()) {
      setMessages((prevMessages) => [
        ...prevMessages,
        { id: prevMessages.length + 1, role: "Me", text: newMessage.trim() },
      ])
      setNewMessage("")
      setLoading(true)
    }
  }

  const getMessageHistoryForAI = () => {
    let messageHistory = []

    if (messages.length > 1) {
      for (let i = 1; i < messages.length - 1; i++) {
        if (messages[i].role == "System") {
          messageHistory.push({
            role: "assistant",
            content: messages[i].text,
          })
        } else {
          messageHistory.push({
            role: "user",
            content: messages[i].text,
          })
        }
      }
    }

    return messageHistory
  }

  const getAndSetResponseFromSystem = async (message) => {
    try {
      let messageHistory = getMessageHistoryForAI()

      let newText = messages[messages.length - 1].text

      let body = {
        reviewId: reviewId,
        text: newText,
        messageHistory: messageHistory,
      }
      const response = await askAI(body)
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          id: prevMessages.length + 1,
          role: "System",
          text: response.answer,
        },
      ])
    } catch (err) {
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          id: prevMessages.length + 1,
          role: "System",
          text: "Oops! some error has occurred. Please try again after some time or check with admin.",
        },
      ])
    }
  }

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSendMessage()
    }
  }

  const parseBoldText = (text) => {
    return text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
  }

  // Animation for loading dots
  const dotStyle = {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    backgroundColor: "#000",
    animation: "dot-blink 1.4s infinite both",
    margin: "0 2px",
  }
  useEffect(() => {
    if (!document.getElementById("dot-blink-keyframes")) {
      const style = document.createElement("style")
      style.id = "dot-blink-keyframes"
      style.innerHTML = `
        @keyframes dot-blink {
          0%, 80%, 100% { opacity: 0; }
          40% { opacity: 1; }
        }
      `
      document.head.appendChild(style)
    }
  }, [])

  useEffect(() => {
    // @ts-ignore
    window.__goToFileLine = goto
    return () => {
      // @ts-ignore
      window.__goToFileLine = undefined
    }
  }, [goto])

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        height: "100%",
        maxHeight: "80vh",
        minHeight: 200,
      }}
    >
      <div style={{ flex: 1, overflowY: "auto", padding: "20px" }}>
        {messages.map((message) => {
          var text = message.text
          //@ts-ignore
          var r = /`?([\/\\0-9a-z_\-]+\.sol)`?( file)?(:| at line )([0-9]*)/gi
          /**test cases for regexp:
          The storage variable `_totalSupply` is declared in the `main.sol` file at line 41.
          */
          text = text.replaceAll(r, (match, file, _fileStr, _sep, line) => {
            return (
              `<span style="color:blue;cursor:pointer;"` +
              `onclick='window.__goToFileLine && window.__goToFileLine(${JSON.stringify(
                file,
              )},${JSON.stringify(line)})'>` +
              `${file} at line ${line}</span>`
            )
          })
          return (
            <div
              key={message.id}
              style={{
                display: "flex",
                justifyContent:
                  message.role === "Me" ? "flex-end" : "flex-start",
                marginBottom: "10px",
                alignItems: "flex-end",
              }}
            >
              <div
                style={{
                  maxWidth: "60%",
                  padding: "10px",
                  borderRadius: "5px",
                  backgroundColor:
                    message.role === "Me" ? "#e0f7fa" : "#ffe0b2",
                  wordWrap: "break-word",
                  whiteSpace: "pre-wrap",
                  fontSize: "16px",
                  marginRight: "10px",
                }}
                dangerouslySetInnerHTML={{ __html: parseBoldText(text) }}
              ></div>
              {message?.role === "System" && message?.id > 1 && (
                <AskAIfeedback
                  type="askAI"
                  submissionText="Your prompt will be shared with our technical team to enhance the product experience."
                  iconDimension={20}
                />
              )}
            </div>
          )
        })}
        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <div style={{ display: "flex", gap: "5px" }}>
              <div style={dotStyle}></div>
              <div style={dotStyle}></div>
              <div style={dotStyle}></div>
            </div>
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px",
          boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
          backgroundColor: "white",
        }}
      >
        <InputBase
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Type a message"
          style={{
            flex: 1,
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            marginRight: "10px",
            fontSize: "16px",
          }}
          disabled={loading}
        />
        <Button
          onClick={handleSendMessage}
          variant="contained"
          color="secondary"
          style={{
            minWidth: "40px",
            minHeight: "40px",
            borderRadius: "50%",
            padding: "0",
          }}
          disabled={loading || !newMessage.trim()}
        >
          <SendIcon />
        </Button>
      </div>
      <div
        style={{
          padding: "10px",
          textAlign: "center",
          color: "#888",
          borderTop: "1px solid #ddd",
          fontWeight: "bold",
        }}
      >
        <span style={{ color: "red" }}>* </span>A.I. models can make mistakes.
        Please independently validate that the output meets your expectations.
      </div>
    </div>
  )
}
